// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file sm/simulation_manager.proto (package vsmr.sm.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { AddTaskRequest, BuildRequest, DeleteTaskRequest, SessionEvent, SessionEventsRequest, SessionId, SessionState, SessionStateList, SimulationId, SimulationInfoList, TaskId, TaskTypeList } from "./simulation_manager_pb.js";

/**
 * ============================================================
 * SimulationManager Service
 *
 * Responsibilities:
 * - Create and manage client sessions.
 * - Build simulations via Builder pattern.
 * - Handle task completion and simulation teardown.
 * - Provide discovery APIs for simulations and task types.
 * - Detect client disconnects via streaming RPC.
 * - Clean up orphaned K8s resources via background GC.
 * ============================================================
 *
 * @generated from service vsmr.sm.v1.SimulationManager
 */
export const SimulationManager = {
  typeName: "vsmr.sm.v1.SimulationManager",
  methods: {
    /**
     * ----------------------------------------------------------
     * CreateSession
     *
     * Creates a new session and opens a long-lived stream used
     * to detect client liveness.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.CreateSession
     */
    createSession: {
      name: "CreateSession",
      I: Empty,
      O: SessionId,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * ----------------------------------------------------------
     * AttachSession
     *
     * Re-binds a client to an EXISTING session (by session_id) and
     * opens a fresh long-lived liveness stream. Used after an SM
     * replica restart: the session's simulations are reconstructed
     * from K8s and the client reconnects to resume control. Fails
     * (NOT_FOUND) if the session is unknown.
     *
     * The first streamed SessionId echoes the attached id; the
     * stream then stays open for liveness, exactly like CreateSession.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.AttachSession
     */
    attachSession: {
      name: "AttachSession",
      I: SessionId,
      O: SessionId,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * ----------------------------------------------------------
     * SubscribeSessionEvents
     *
     * Control-plane lifecycle events for the session's simulations,
     * pushed as they happen. The stream first replays retained
     * events after the (after_epoch, after_seq) cursor (per-session
     * ring buffer, best-effort; a cursor from another log generation
     * replays everything retained), then stays open. Lets clients learn task
     * teardown even when the data-plane streams (Kafka) are down —
     * the liveness stream stays untouched (its disconnect/grace
     * semantics drive teardown and must not carry data).
     *
     * Context:
     * - session_id MUST also be provided via gRPC metadata
     *   (owner routing, like every session-scoped RPC).
     * Fails (NOT_FOUND) if the session is unknown.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.SubscribeSessionEvents
     */
    subscribeSessionEvents: {
      name: "SubscribeSessionEvents",
      I: SessionEventsRequest,
      O: SessionEvent,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * ----------------------------------------------------------
     * GetSessionState
     *
     * Snapshot of a session for client-side restore after a
     * re-attach: its simulations with registry-level status and
     * task metadata. Without this, only a client that heard every
     * event from the start could rebuild its view.
     *
     * Context:
     * - session_id MUST also be provided via gRPC metadata
     *   (owner routing, like every session-scoped RPC).
     * Fails (NOT_FOUND) if the session is unknown.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.GetSessionState
     */
    getSessionState: {
      name: "GetSessionState",
      I: SessionId,
      O: SessionState,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * ListSessions
     *
     * Snapshot list of the sessions owned by THIS replica (SM has
     * no user concept — per-user listing is the BFF's, on top of
     * its user↔session mapping). Discovery for monitoring and the
     * session-management surface.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.ListSessions
     */
    listSessions: {
      name: "ListSessions",
      I: Empty,
      O: SessionStateList,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * CreateSimulation
     *
     * Creates a new empty simulation in BUILDING state.
     * Must be followed by AddTask(s) and Build.
     *
     * Context:
     * - session_id MUST be provided via gRPC metadata.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.CreateSimulation
     */
    createSimulation: {
      name: "CreateSimulation",
      I: Empty,
      O: SimulationId,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * AddTask
     *
     * Adds a task definition to a simulation in BUILDING state.
     * No K8s resources are created at this point.
     * Returns a task_id of the form "{sim_id}-{index}".
     *
     * Context:
     * - session_id MUST be provided via gRPC metadata.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.AddTask
     */
    addTask: {
      name: "AddTask",
      I: AddTaskRequest,
      O: TaskId,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * Build
     *
     * Materializes the simulation: provisions K8s resources
     * (Jobs, Services, gRPC channels) for all added tasks.
     * For co-simulation, also provisions shared resources
     * (PVC for exchange directory, ConfigMap for shared configs).
     *
     * The simulation type (single vs co-simulation) is
     * determined by the number of tasks and shared_configs.
     *
     * Context:
     * - session_id MUST be provided via gRPC metadata.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.Build
     */
    build: {
      name: "Build",
      I: BuildRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * DeleteTask
     *
     * Called by the adapter when a task completes or is stopped.
     * Cleans up K8s resources (Job, Service, gRPC channel) for
     * the individual task.
     *
     * For co-simulation, the simulation's shared resources
     * (PVC, ConfigMap) are cleaned up only when ALL tasks in
     * the simulation have been deleted.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.DeleteTask
     */
    deleteTask: {
      name: "DeleteTask",
      I: DeleteTaskRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * ListSimulations
     *
     * Returns a snapshot list of all simulations.
     * Each simulation includes its task metadata.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.ListSimulations
     */
    listSimulations: {
      name: "ListSimulations",
      I: Empty,
      O: SimulationInfoList,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * ListTaskTypes
     *
     * Returns all registered task types.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.sm.v1.SimulationManager.ListTaskTypes
     */
    listTaskTypes: {
      name: "ListTaskTypes",
      I: Empty,
      O: TaskTypeList,
      kind: MethodKind.Unary,
    },
  }
} as const;

